import { render, staticRenderFns } from "./tabPacksImages.vue?vue&type=template&id=3d281602&"
import script from "./tabPacksImages.vue?vue&type=script&lang=js&"
export * from "./tabPacksImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports